import React from "react";
import { Stack, Text, Icon } from "@fluentui/react";

export interface StepItem {
    id: number;
    title: string;
}

interface Props {
    currentStep: number;
    maxStep: number;
}

const steps: StepItem[] = [
    { id: 1, title: "Welcome" },
    { id: 2, title: "Your Details" },
    { id: 3, title: "Select Edition" },
    { id: 4, title: "Select Apps" },
    { id: 5, title: "Summary" },
    { id: 6, title: "Login Details" }
];

export const CreateAccountStepper: React.FC<Props> = ({ currentStep, maxStep }) => {

    const renderIcon = (stepId: number) => {

        if (stepId < currentStep) {
            return (
                <Icon
                    iconName="CompletedSolid"
                    styles={{ root: { color: "#2ECC71", fontSize: 16 } }}
                />
            );
        }

        if (stepId === currentStep) {
            return (
                <Icon
                    iconName="RadioBtnOn"
                    styles={{ root: { color: "#FFFFFF", fontSize: 16 } }}
                />
            );
        }

        if (stepId <= maxStep) {
            return (
                <Icon
                    iconName="CompletedSolid"
                    styles={{ root: { color: "#FFA500", fontSize: 16 } }}
                />
            );
        }

        return (
            <Icon
                iconName="RadioBtnOff"
                styles={{ root: { color: "#7FA6D6", fontSize: 16 } }}
            />
        );
    };

    return (
        <Stack
            tokens={{ childrenGap: 0 }}
            styles={{ root: { width: "100%", padding: "10px 20px" } }}
        >
            <Text
                variant="mediumPlus"
                styles={{
                    root: {
                        marginBottom: 20,
                        fontWeight: 600,
                        color: "#FFFFFF"
                    }
                }}
            >
                Account Setup
            </Text>

            {steps.map((step, index) => (
                <Stack
                    key={step.id}
                    horizontal
                    tokens={{ childrenGap: 10 }}
                    styles={{
                        root: {
                            paddingBottom: index < steps.length - 1 ? 20 : 0
                        }
                    }}
                >
                    <Stack horizontalAlign="center" styles={{ root: { width: 20 } }}>
                        {renderIcon(step.id)}

                        {index < steps.length - 1 && (
                            <div
                                style={{
                                    width: 2,
                                    height: 28,
                                    background: "rgba(255,255,255,0.25)",
                                    marginTop: 2
                                }}
                            />
                        )}
                    </Stack>

                    <Text
                        styles={{
                            root: {
                                fontWeight: step.id === currentStep ? 600 : 400,
                                color: step.id === currentStep
                                    ? "#FFFFFF"
                                    : "#C8D6F0"
                            }
                        }}
                    >
                        {step.title}
                    </Text>
                </Stack>
            ))}
        </Stack>
    );
};